export default {
    /**
     * Get 各種リスト情報取得
     */
    loadListObj (obj) {
        let url = obj.url
        let data = obj.data
        if (obj.data) {
            return axios.get(route(url, data))
        } else {
            return axios.get(route(url))
        }
    },

    /**
     * Get 各種リスト情報取得(see more)
     */
    loadListObjSeeMore (data) {
        if (typeof(data) == 'string') {
            return axios.get(data)
        }
        // 手動モード
        let url = data.url
        let skip = data.skip
        return axios.get(route(url, skip))
    },

    /**
     * Post リストから削除
     */
    listItemDelete (data) {
        let url = data.url
        let obj = new Object()
        obj.key = data.key
        return axios.post(route(url), obj)
    },

    /**
     * Get ユーザー情報取得
     */
    getUser () {
        return axios.get(route('user.get'))
    },

    /**
     * Get 個人情報取得
     */
    loadPrivateInfo (data) {
        return axios.get(route('private.get', data.userId))
    },

    /**
     * Get 郵便住所
     */
//    loadAddress (data) {
//        return axios.post(route('com.address'), data) 
//    }
    
    /**
     * Get カスタマイズシェアURL取得(案件・要員)
     */
    loadCustShareUrl (data) {
        return axios.post(route('cust.share.url'), data) 
    },

    /**
     * unique チェック
     */
    uniqueCheck (data) {
        return axios.post(route('com.unique', data)) 
    },

    /**
     * selectGroup送信
     */
    sendMailCommon (data) {
        return axios.post(route('com.send.mail'), data) 
    },

    /**
     * 応募詳細メッセージ
     */
    addApplyHisMsg (data) {
        return axios.post(route('com.apply.his.msg.add'), data) 
    },
}
